var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M31.6667 21.3892C31.6667 20.4692 32.4133 19.7225 33.3333 19.7225C34.2533 19.7225 35 20.4692 35 21.3892V30.6658C35 33.0558 33.055 35.0008 30.6667 35.0008H9.33333C6.945 35.0008 5 33.0558 5 30.6658V9.33416C5 6.94416 6.945 5.00083 9.33333 5.00083H25.2783C26.1983 5.00083 26.945 5.74583 26.945 6.6675C26.945 7.5875 26.1983 8.33416 25.2783 8.33416H9.33333C8.78167 8.33416 8.33333 8.7825 8.33333 9.33416V30.6658C8.33333 31.2175 8.78167 31.6675 9.33333 31.6675H30.6667C31.2183 31.6675 31.6667 31.2175 31.6667 30.6658V21.3892ZM15.516 18.2442C16.1827 17.6075 17.236 17.6342 17.8727 18.2992L20.381 20.9292L30.4693 10.5075C31.1077 9.8475 32.1627 9.8275 32.826 10.4692C33.4877 11.1092 33.5043 12.1642 32.8643 12.8258L21.5693 24.4925C21.256 24.8175 20.8243 25.0008 20.3727 25.0008H20.366C19.9127 24.9992 19.4793 24.8125 19.166 24.4842L15.461 20.6008C14.8243 19.9342 14.851 18.8792 15.516 18.2442Z",
          fill: _vm.color
        }
      }),
      _c(
        "mask",
        {
          staticStyle: { "mask-type": "luminance" },
          attrs: {
            id: _vm.maskId,
            maskUnits: "userSpaceOnUse",
            x: "5",
            y: "5",
            width: _vm.size,
            height: _vm.size
          }
        },
        [
          _c("path", {
            attrs: {
              "fill-rule": "evenodd",
              "clip-rule": "evenodd",
              d:
                "M31.6667 21.3892C31.6667 20.4692 32.4133 19.7225 33.3333 19.7225C34.2533 19.7225 35 20.4692 35 21.3892V30.6658C35 33.0558 33.055 35.0008 30.6667 35.0008H9.33333C6.945 35.0008 5 33.0558 5 30.6658V9.33416C5 6.94416 6.945 5.00083 9.33333 5.00083H25.2783C26.1983 5.00083 26.945 5.74583 26.945 6.6675C26.945 7.5875 26.1983 8.33416 25.2783 8.33416H9.33333C8.78167 8.33416 8.33333 8.7825 8.33333 9.33416V30.6658C8.33333 31.2175 8.78167 31.6675 9.33333 31.6675H30.6667C31.2183 31.6675 31.6667 31.2175 31.6667 30.6658V21.3892ZM15.516 18.2442C16.1827 17.6075 17.236 17.6342 17.8727 18.2992L20.381 20.9292L30.4693 10.5075C31.1077 9.8475 32.1627 9.8275 32.826 10.4692C33.4877 11.1092 33.5043 12.1642 32.8643 12.8258L21.5693 24.4925C21.256 24.8175 20.8243 25.0008 20.3727 25.0008H20.366C19.9127 24.9992 19.4793 24.8125 19.166 24.4842L15.461 20.6008C14.8243 19.9342 14.851 18.8792 15.516 18.2442Z"
            }
          })
        ]
      ),
      _c("g", { attrs: { mask: "url(#" + _vm.maskId + ")" } }, [
        _c("rect", {
          attrs: { width: _vm.size, height: _vm.size, fill: _vm.colorInternal }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }